import './assets/styles/main.scss';
import SettingsRoutes from './routes/SettingsRoutes';

export default SettingsRoutes;
